import { Component, OnInit, OnDestroy } from '@angular/core';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {Router,ActivatedRoute } from '@angular/router';
import {AddTransactionComponent} from '../../components/add-transaction/add-transaction.component';
import { TransactionService } from '../../services/transaction.service' 
import Swal from 'sweetalert2';
import { environment } from '../../../../../environments/environment'
import{ JobService } from '../../../intake/services/job/job.service'
import { ShellService } from '../../../../shell/shell.service';
import { openPrintable, plainAmount } from '../../../../shared/utils/printable.util';

@Component({
  selector: 'app-accounting-transactions-list',
  templateUrl: './accounting-transactions-list.component.html',
  styleUrls: ['./accounting-transactions-list.component.scss']
})
export class AccountingTransactionsListComponent implements OnInit, OnDestroy {
  public oldSite = environment.apiSite;
  public location = '' ;
  jobId
  recordsCount = 0;
  transactionList;
  loderDivShow = true;
  loading = false;
  public allJobsData;
  showJobsDropdown = false;  
  parentChildJobId;
  constructor(
    config: NgbModalConfig,
    private modalService: NgbModal,
    private _router: Router,
    private router: ActivatedRoute,
    private transactionService: TransactionService,
    private jobService : JobService,
    private shell: ShellService
  ) { 
    let locationHash = _router.url.split("/");
  	if(locationHash.length >= 2){
  		this.location = locationHash[1]+'/'+locationHash[2];
  	}
    config.backdrop = 'static';
    config.keyboard = false;
  }

  ngOnInit() {
    this.shell.homeInspections$.subscribe(enabled => this.homeInspections = enabled);
    this.router.params.subscribe(params => {
      if (params.jobId) {
       this.jobId = params.jobId;
       this.parentChildJobId = this.jobId;
       this.getAllJobs();
       this.showJobsDropdown = true;
      } else {
        this.showJobsDropdown = false;
      }
      // Reloaded when the related-reports menu switches job.
      this.loderDivShow = true;
      this.getTransactions();
    })
  }
  openFormModal(id) {
    const modalRef = this.modalService.open(AddTransactionComponent,{size:'lg'});
    modalRef.componentInstance.jobId = this.jobId;
    modalRef.result.then((result) => {
      this.getTransactions();
    }).catch((error) => {
        console.log(error);
    });
  }

  getTransactions() {
    this.transactionService.getAllTransactions(this.jobId).subscribe(
      data => {
        this.recordsCount = data.result.data.length;
        this.transactionList = data.result.data;
        console.log(data);
        this.loderDivShow = false;
      }
    )
  }

  deleteTransaction(transaction_id) {
    Swal({
      title: 'Are you sure?',
      text: 'Delete Transaction!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
        this.transactionService.deleteTransaction(transaction_id).subscribe(
          data => {
                console.log(data);
                this.getTransactions();
                Swal(
                  'Deleted!',
                  'Transaction has been deleted.',
                  'success'
                )
          } 
         );
        
    } else if (result.dismiss === Swal.DismissReason.cancel) {
       
      }
    })
  }

  makeBillingStatementPdf() {
    this.loading = true
    this.transactionService.generateBillingStatement(this.jobId).subscribe(
      data => {
        this.loading  = false
        if(data.status==200) {
          // this.getTransactions();
          Swal(
            'Success!',
            data.result.message,
            'success'
          )
        } else if(data.status==400){
          Swal(
            'Error!',
            data.result.message,
            'warning'
          )
        }
      }
    )  
  }

  getAllJobs() {
    this.jobService.getAllJobs(this.jobId).subscribe(
      data => {
        console.log(data);
        this.allJobsData = data.result.data;
          console.log(this.allJobsData);
        this.updateHeader();
      }
    )
}

goTotheParentJob() {
  window.location.href = this.location+'/'+this.parentChildJobId; 
}

  // Related-reports menu in the workflow bar.
  // (goTotheParentJob() above built a relative URL, which doubled the path; this navigates.)
  goToJob(jobId) {
    this.parentChildJobId = jobId;
    this._router.navigate(['/transaction/list', jobId]);
  }

  // App top bar, as on the other inspection pages (mockup transactions): the job's address over
  // its report number, linking to the overview.
  updateHeader() {
    const job = (this.allJobsData || []).find(j => j.job_id == this.jobId);
    const hasAddress = !!(job && job.property && job.property.property_address1);
    this.shell.setPageHeader({
      title: hasAddress ? this.addressOf(job) : 'Transactions',
      subtitle: job ? 'Report #' + [job.job_id, job.job_ref_suffix].filter(v => v).join(' ') : '',
      subtitleLink: job ? '/inspections-completed-sheet/' + this.jobId : ''
    });
  }

  /** Home / Termite Inspection: a home inspection's tab bar has no termite tabs (null: loading). */
  get service(): string {
    if (!this.allJobsData || this.homeInspections === null) {
      return null;
    }
    return ShellService.serviceOf(this.allJobsData.find(j => j.job_id == this.jobId), this.homeInspections);
  }

  // HOME_INSPECTIONS (ShellService.homeInspections$); null until known.
  homeInspections: boolean = null;

  /** Address for the printed heading. */
  get currentAddress(): string {
    const job = (this.allJobsData || []).find(j => j.job_id == this.jobId);
    return job && job.property ? this.addressOf(job) : '';
  }

  /**
   * Printable View (twin-ci accounting_print): a plain page with the same transactions as on
   * screen (by Ref), print dialog opened. Falls back to printing this page if pop-ups are blocked.
   */
  print() {
    const subType = t => t.transaction_sub_type == 'Credit Card Processing Fee' ? 'Credit Card Fee - Completion' : t.transaction_sub_type;
    const opened = openPrintable({
      title: 'Transactions - Report #' + this.jobId,
      heading: 'Transactions: ' + this.currentAddress + '   Report #: ' + this.jobId,
      columns: ['By', 'Date', 'Ref.', 'Description', 'Inspector', 'Charge', 'Payment', 'Balance', 'Transaction Type', 'Sub Type'],
      numeric: [5, 6, 7],
      rows: (this.transactionList || []).map(t => [t.by_name, t.date_posted, t.ref_text, t.description, t.inspector,
        plainAmount(t.transaction_charge), plainAmount(t.transaction_payment), plainAmount(t.bal), t.transaction_work_type, subType(t)]),
    });
    if (!opened) {
      window.print();
    }
  }

  addressOf(job): string {
    const p = job.property || {};
    const cityState = [p.property_city, p.property_state].filter(v => v).join(', ');
    return [p.property_address1, p.property_address2, cityState].filter(v => v).join(', ')
      + (p.property_zip ? ' ' + p.property_zip : '');
  }

  ngOnDestroy() {
    this.shell.setPageHeader(null);
  }

}
